import { FaShieldAlt, FaTree, FaUsers } from 'react-icons/fa';

const whyChooseUs = {  
    sub: "Why Choose Us",
    heading: "Elevate Your Outdoor Space with Superior Solutions",
    description: "Ensure your houseplants thrive with these essential care tips. Learn how to provide proper light, water, and nutrients for vibrant indoor greenery.",
    points: [
        { 
            id: 1,
            icon: <FaTree />,
            title: 'Custom Solutions',
            content: 'We provide customized gardening and landscaping solutions tailored to your specific preferences and outdoor area requirements.',
        },
        {
            id: 2,
            icon: <FaShieldAlt />,
            title: 'Quality Assurance',
            content: 'Our team ensures top-notch quality in every project, guaranteeing durable and aesthetically pleasing results for your outdoor space.',
        },
        {
            id: 3,
            icon: <FaUsers />,
            title: 'Professional Team',
            content: 'Backed by a team of skilled professionals, we deliver expert gardening and landscaping services, ensuring satisfaction with every project.',
        },
    ]
}

export default whyChooseUs;